import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  instructorId: Yup.string().required("This field is required"),
});

export default validationSchema;
